"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTempData = void 0;
var _react = require("react");
var _AudiencePickerProvider = require("../AudiencePickerProvider.helpers");
const emptyArray = [];
const useTempData = function () {
  let studentsIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray;
  let singleStudentsIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  let classesMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let groupsMapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let studentsMapper = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  const [groupsSelectorTempData, setGroupsSelectorTempData] = (0, _react.useState)({
    selectedGroupsIds: [],
    selectedClassesIds: []
  });
  const [studentsSelectorTempData, setStudentsSelectorTempData] = (0, _react.useState)({
    selectedStudentsIds: [],
    groupSearchText: '',
    isGroupSearchOpen: false,
    studentsSearchText: '',
    isStudentsSearchOpen: false,
    selectedGroup: ''
  });
  const [createGroupTempData, setCreateGroupTempData] = (0, _react.useState)({
    groupName: '',
    newGroupName: '',
    groupId: ''
  });
  (0, _react.useEffect)(() => {
    let isOn = false;
    const onClick = () => {
      setStudentsSelectorTempData({
        ...studentsSelectorTempData,
        isGroupSearchOpen: false
      });
    };
    if (studentsSelectorTempData.isGroupSearchOpen) {
      isOn = true;
      document.addEventListener('click', onClick);
    }
    return () => {
      if (isOn) {
        document.removeEventListener('click', onClick);
      }
    };
  }, [studentsSelectorTempData, studentsSelectorTempData.isGroupSearchOpen, studentsSelectorTempData.groupSearchText]);
  const getStudentsSearchList = (0, _react.useCallback)(() => {
    const getStudentsList = () => {
      if (!studentsSelectorTempData.isStudentsSearchOpen) {
        if (studentsSelectorTempData.selectedGroup === 'all') {
          return studentsIds;
        } else if (studentsSelectorTempData.selectedGroup === 'singleStudents') {
          return singleStudentsIds;
        }
        return classesMapper && classesMapper[studentsSelectorTempData.selectedGroup]?.studentIds || groupsMapper && groupsMapper[studentsSelectorTempData.selectedGroup]?.studentIds || [];
      }
      if (!studentsSelectorTempData.studentsSearchText || studentsSelectorTempData.studentsSearchText.length < 2) {
        return [];
      }
      let studentsListMapper = {};
      studentsSelectorTempData.studentsSearchText.toLowerCase().split(' ').filter(key => !!key).sort((a, b) => {
        const aLength = a.length;
        const bLength = b.length;
        if (aLength < bLength) {
          return 1;
        }
        if (aLength > bLength) {
          return -1;
        }
        return 0;
      }).forEach(key => {
        studentsIds?.forEach(id => {
          if (studentsMapper && studentsMapper[id] && (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student).indexOf(key) >= 0) {
            if (!studentsListMapper[id]) {
              studentsListMapper[id] = {
                id: id,
                key: '',
                fullName: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student),
                fullNameHtml: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student)
              };
            }
            const re = new RegExp(key, 'gi');
            studentsListMapper[id].key += key;
            studentsListMapper[id].fullNameHtml = studentsListMapper[id].fullNameHtml.replace(re, `<span>${key}</span>`);
          }
        });
      });
      return Object.keys(studentsListMapper).sort((a, b) => {
        const aKeyLength = studentsListMapper[a].key.length;
        const bKeyLength = studentsListMapper[b].key.length;
        if (aKeyLength < bKeyLength) {
          return 1;
        }
        if (aKeyLength > bKeyLength) {
          return -1;
        }
        if ((0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[a]) < (0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[b])) {
          return -1;
        }
        if ((0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[a]) > (0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[b])) {
          return 1;
        }
        return 0;
      }).map(id => studentsListMapper[id]);
    };
    if (studentsSelectorTempData && studentsIds && studentsMapper && classesMapper && groupsMapper) {
      return getStudentsList();
    }
    return [];
  }, [classesMapper, groupsMapper, singleStudentsIds, studentsIds, studentsMapper, studentsSelectorTempData]);
  return {
    groupsSelectorTempData,
    setGroupsSelectorTempData,
    studentsSelectorTempData,
    setStudentsSelectorTempData,
    createGroupTempData,
    setCreateGroupTempData,
    getStudentsSearchList
  };
};
exports.useTempData = useTempData;